
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import styles from '../../styles/home/eliteTradersSection.module.scss';
export default function EliteTradersSection() {
    return (<section className={styles.eliteTradersSection}>
      {/* Background vectors */}
      <div className={styles.vectorsLeft1}>
        <img src="/images/traders/vector-2.svg" alt="" role="presentation"/>
      </div>
      <div className={styles.vectorsLeft2}>
        <img src="/images/traders/vector-3.svg" alt="" role="presentation"/>
      </div>
      <div className={styles.vectorsRight1}>
        <img src="/images/traders/vector-2.svg" alt="" role="presentation"/>
      </div>
      <div className={styles.vectorsRight2}>
        <img src="/images/traders/vector-3.svg" alt="" role="presentation"/>
      </div>

      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Capital allocation powered by elite execution</h2>
          <div className={styles.subtitle}>
            <p>Allocate funds to vetted professional traders, select a strategy profile, and receive proportional participation in realized performance.</p>
          </div>
        </div>

        <div className={styles.logosContainer}>
          <div className={styles.logoCard} style={{ background: 'rgba(255, 224, 24, 1)' }}>
            <img src="/images/traders/midas.png" alt="Midas" className={styles.logoImage} style={{ width: '128.114px', height: '72px' }}/>
          </div>

          <div className={styles.logoCard}>
            <img src="/images/traders/amber.png" alt="Amber" className={styles.logoImage} style={{ width: '106.316px', height: '20px' }}/>
          </div>

          <div className={styles.logoCard}>
            <img src="/images/traders/onyx.png" alt="Onyx Cloud" className={styles.logoIcon}/>
          </div>
        </div>
      </div>
    </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f3cf__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//EliteTradersSection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f3cf__ as getStaticProps }
  